"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2334],{

/***/ 20293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Dashed; },
/* harmony export */   "D": function() { return /* binding */ Solid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Dashed = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    border-top: 1px dashed ".concat(theme.palette.background.line, ";\n  ");
});
const Solid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    border-top: 1px solid ".concat(theme.palette.background.line, ";\n  ");
});


/***/ }),

/***/ 59811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CopySVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const CopySVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "ic_copy",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M3.293 3.293A1 1 0 014 3h9a1 1 0 011 1v1a1 1 0 102 0V4a3 3 0 00-3-3H4a3 3 0 00-3 3v9a3 3 0 003 3h1a1 1 0 100-2H4a1 1 0 01-1-1V4a1 1 0 01.293-.707zM10 11a1 1 0 011-1h9a1 1 0 011 1v9a1 1 0 01-1 1h-9a1 1 0 01-1-1v-9zm1-3a3 3 0 00-3 3v9a3 3 0 003 3h9a3 3 0 003-3v-9a3 3 0 00-3-3h-9z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 18680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const MetaTags = (param)=>{
    let { resolvedUrl , album , photoClassifications  } = param;
    var _album_keywords, _spaceClassification_tags, _styleClassification_tags, _spaceTags_map, _styleTags_map, _photo_image;
    const photo = album === null || album === void 0 ? void 0 : album.frontCover;
    const pathName = resolvedUrl.split("?")[0];
    const photoIdQs = (photo === null || photo === void 0 ? void 0 : photo.urlId) || "";
    const path = "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName) + (photoIdQs ? "?photoId=".concat(photoIdQs) : "");
    const title = (album === null || album === void 0 ? void 0 : album.name) ? "".concat(album.name, "－信義居家") : "信義居家";
    const keywords = album === null || album === void 0 ? void 0 : (_album_keywords = album.keywords) === null || _album_keywords === void 0 ? void 0 : _album_keywords.map((keyword)=>keyword.name).join(",");
    const spaceClassification = photoClassifications === null || photoClassifications === void 0 ? void 0 : photoClassifications.find((classification)=>classification.name === "空間");
    const styleClassification = photoClassifications === null || photoClassifications === void 0 ? void 0 : photoClassifications.find((classification)=>classification.name === "風格");
    const spaceTags = spaceClassification === null || spaceClassification === void 0 ? void 0 : (_spaceClassification_tags = spaceClassification.tags) === null || _spaceClassification_tags === void 0 ? void 0 : _spaceClassification_tags.filter((tag)=>{
        var _photo_tags;
        return photo === null || photo === void 0 ? void 0 : (_photo_tags = photo.tags) === null || _photo_tags === void 0 ? void 0 : _photo_tags.find((photoTag)=>photoTag.urlId === tag.urlId);
    });
    const styleTags = styleClassification === null || styleClassification === void 0 ? void 0 : (_styleClassification_tags = styleClassification.tags) === null || _styleClassification_tags === void 0 ? void 0 : _styleClassification_tags.filter((tag)=>{
        var _photo_tags;
        return photo === null || photo === void 0 ? void 0 : (_photo_tags = photo.tags) === null || _photo_tags === void 0 ? void 0 : _photo_tags.find((photoTag)=>photoTag.urlId === tag.urlId);
    });
    const spaceTagNames = (_spaceTags_map = spaceTags === null || spaceTags === void 0 ? void 0 : spaceTags.map((tag)=>tag.name)) === null || _spaceTags_map === void 0 ? void 0 : _spaceTags_map.join("、");
    const styleTagNames = (_styleTags_map = styleTags === null || styleTags === void 0 ? void 0 : styleTags.map((tag)=>tag.name)) === null || _styleTags_map === void 0 ? void 0 : _styleTags_map.join("、");
    let description = "".concat(album === null || album === void 0 ? void 0 : album.name, "，信義居家這次蒐集的設計案例是").concat(spaceTagNames, "規劃，採用").concat(styleTagNames, "作空間風格主調，趕緊來一起看看該怎麼為").concat(spaceTagNames, "做出完美設計吧！");
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "裝修圖輯",
                item: "https://livinglife.com.tw/album"
            },
            {
                "@type": "ListItem",
                position: 3,
                name: album === null || album === void 0 ? void 0 : album.name,
                item: path
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: path
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }, "keywords"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "本網頁著作權屬信義房屋股份有限公司, All Rights Reserved"
            }, "copyright"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "application-name",
                content: "信義居家好生活"
            }, "application-name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: (photo === null || photo === void 0 ? void 0 : (_photo_image = photo.image) === null || _photo_image === void 0 ? void 0 : _photo_image.url) || ""
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: path
            }, "og:url"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 22334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Album_AlbumContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/lodash-es/includes.js + 2 modules
var includes = __webpack_require__(19658);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useAlbum.js


const useAlbum = function() {
    let urlId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, swrOptions = arguments.length > 1 ? arguments[1] : void 0;
    const { data , ...rest } = (0,fetchers/* useCustomSWR */.LW)(urlId && "/albums?".concat((0,lib.stringify)({
        urlId
    })), swrOptions);
    return {
        data: data === null || data === void 0 ? void 0 : data[0],
        ...rest
    };
};

;// CONCATENATED MODULE: ./utils/api/hooks/usePhotos.js


const usePhotos = function() {
    let albumId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, swrOptions = arguments.length > 2 ? arguments[2] : void 0;
    const { data , ...rest } = (0,fetchers/* useCustomSWR */.LW)(albumId && "/photos?".concat((0,lib.stringify)({
        album: albumId,
        ...options
    })), swrOptions);
    // data 會無預期出現nested data，不清楚為什麼，
    // 先避免該狀況出現
    return (data === null || data === void 0 ? void 0 : data.data) ? {
        data: [],
        ...rest
    } : {
        data,
        ...rest
    };
};

// EXTERNAL MODULE: ./utils/api/hooks/usePhotoClassifications.js
var usePhotoClassifications = __webpack_require__(57874);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/setPhotoViewed.js

const setPhotoViewed = (photoId)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsPut */.OL)("/photos/".concat(photoId, "/views")));
};

// EXTERNAL MODULE: ./utils/hooks/analytics/constants.js
var constants = __webpack_require__(42395);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./utils/hooks/analytics/GtmAgent/useGtmAlbumPageView.js



const useGtmAlbumPageView = function(album, photos) {
    let photoUrlId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const [initialPageViewSent, setInitialPageViewSent] = (0,react.useState)(false);
    const [prevPhotoUrlId, setPrevPhotoUrlId] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const genPageViewData = ()=>{
            var _album_frontCover, _album_frontCover_tags;
            if (!album || !photos) {
                return null;
            }
            if (photoUrlId) {
                var _photo_tags;
                const photo = photos === null || photos === void 0 ? void 0 : photos.find((p)=>p.urlId === photoUrlId);
                return {
                    event: constants/* ALBUM_DETAIL */.YT,
                    photo_tag: photo === null || photo === void 0 ? void 0 : (_photo_tags = photo.tags) === null || _photo_tags === void 0 ? void 0 : _photo_tags.map((tag)=>tag.urlId).join(","),
                    photo_id: photo === null || photo === void 0 ? void 0 : photo.urlId,
                    album_id: album === null || album === void 0 ? void 0 : album.urlId
                };
            }
            return {
                event: constants/* ALBUM_PAGEVIEW */.q6,
                photo_tag: (_album_frontCover = album.frontCover) === null || _album_frontCover === void 0 ? void 0 : (_album_frontCover_tags = _album_frontCover.tags) === null || _album_frontCover_tags === void 0 ? void 0 : _album_frontCover_tags.map((tag)=>tag.urlId).join(","),
                album_id: album === null || album === void 0 ? void 0 : album.urlId
            };
        };
        if (!initialPageViewSent || prevPhotoUrlId !== photoUrlId) {
            const data = genPageViewData();
            if (data !== null) {
                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM(data);
                setPrevPhotoUrlId(photoUrlId);
                if (!initialPageViewSent) {
                    setInitialPageViewSent(true);
                }
            }
        }
    }, [
        album,
        photos,
        photoUrlId
    ]);
};

// EXTERNAL MODULE: ./components/common/PopupSearchPanel/hooks.js
var hooks = __webpack_require__(14581);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/SVGElements/Close.js
var Close = __webpack_require__(71908);
// EXTERNAL MODULE: ./components/common/SVGElements/Eye.js
var Eye = __webpack_require__(23183);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/Divider/index.js
var Divider = __webpack_require__(20293);
// EXTERNAL MODULE: ./components/common/VenderLink/index.js
var VenderLink = __webpack_require__(90879);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/PhotoCarousel.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  object-fit: contain;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}









const modules = [
    swiper_esm/* Navigation */.W_
];
const StyledSwiper = (0,emotion_styled_browser_esm/* default */.Z)(swiper_react/* Swiper */.tq)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .photo-swiper-prev, .photo-swiper-next {\n      display: none;\n    }\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      &.swiper,\n      &.swiper > .swiper-wrapper,\n      &.swiper > .swiper-wrapper > .swiper-slide {\n        height: 100%;\n      }\n\n      .photo-swiper-prev, .photo-swiper-next {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: calc(50% - 18px);\n        width: 36px;\n        height: 36px;\n        background: rgba(240, 240, 240, 0.8);\n        border-radius: 50%;\n        cursor: pointer;\n        z-index: 1;\n\n        > .MuiSvgIcon-root {\n          font-size: 1rem;\n        }\n      }\n      .photo-swiper-prev {\n        left: 24px;\n        padding-left: 6px;\n      }\n      .photo-swiper-next {\n        right: 24px;\n        padding-left: 2px;\n      }\n\n    }\n  ");
});
const ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    padding-top: 75%;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      padding-top: unset;\n      height: 100%;\n    }\n  ");
});
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
const ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
const swiperNavigation = {
    nextEl: ".photo-swiper-next",
    prevEl: ".photo-swiper-prev"
};
const PhotoCarousel = (param)=>{
    let { photos , photoUrlId , setPhotoUrlId , frontCoverUrlId  } = param;
    const [swiper, setSwiper] = (0,react.useState)(null);
    const [frontCoverIndex, setFrontCoverIndex] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const frontCoverIndex = photos === null || photos === void 0 ? void 0 : photos.findIndex((photo)=>photo.urlId === frontCoverUrlId);
        if (frontCoverIndex > -1) {
            setFrontCoverIndex(frontCoverIndex);
        }
    }, [
        photos,
        frontCoverUrlId
    ]);
    (0,react.useEffect)(()=>{
        if (!swiper) {
            return;
        }
        const index = photos === null || photos === void 0 ? void 0 : photos.findIndex((photo)=>photo.urlId === photoUrlId);
        if (index > -1 && (swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) !== index) {
            swiper.slideTo(index);
        }
    }, [
        photos,
        photoUrlId,
        swiper
    ]);
    const onIndexChange = (swiper)=>{
        const index = swiper.realIndex;
        const photo = index > -1 ? photos === null || photos === void 0 ? void 0 : photos[index] : null;
        if (photo && photo.urlId !== photoUrlId) {
            setPhotoUrlId(photo.urlId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper, {
        modules: modules,
        slidesPerView: "auto",
        loop: !!(photos === null || photos === void 0 ? void 0 : photos.length),
        centeredSlides: true,
        navigation: !!(photos === null || photos === void 0 ? void 0 : photos.length) ? swiperNavigation : false,
        onAfterInit: (swiper)=>setSwiper(swiper),
        onRealIndexChange: onIndexChange,
        children: [
            (photos === null || photos === void 0 ? void 0 : photos.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "photo-swiper-next",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "photo-swiper-prev",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            photos === null || photos === void 0 ? void 0 : photos.map((photo, index)=>{
                var _photo_image;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Absolute, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: photo === null || photo === void 0 ? void 0 : (_photo_image = photo.image) === null || _photo_image === void 0 ? void 0 : _photo_image.url,
                                    alt: photo === null || photo === void 0 ? void 0 : photo.description,
                                    style: {
                                        objectFit: "contain"
                                    },
                                    fill: true,
                                    priority: frontCoverIndex === index,
                                    quality: 60
                                })
                            })
                        })
                    })
                }, photo._id);
            })
        ]
    });
};
PhotoCarousel.defaultProps = {
    photos: []
};
/* harmony default export */ var AlbumContent_PhotoCarousel = (PhotoCarousel);

;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/PhotoThumb.js

function PhotoThumb_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PhotoThumb_templateObject = function() {
        return data;
    };
    return data;
}
function PhotoThumb_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    PhotoThumb_templateObject1 = function() {
        return data;
    };
    return data;
}


const PhotoThumb_ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(PhotoThumb_templateObject(), (param)=>{
    let { theme , $selected  } = param;
    return "\n    position: relative;\n    padding-top: 100%;\n    width: 58px;\n    height: 58px;\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid ".concat($selected ? theme.palette.primary.main : "transparent", ";\n    box-sizing: border-box;\n    cursor: pointer;\n  ");
});
const Img = emotion_styled_browser_esm/* default.img */.Z.img(PhotoThumb_templateObject1());
const PhotoThumb = (param)=>{
    let { photo , isSelected , onClick  } = param;
    var _photo_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoThumb_ImgRect, {
        $selected: isSelected,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
            src: photo === null || photo === void 0 ? void 0 : (_photo_image = photo.image) === null || _photo_image === void 0 ? void 0 : _photo_image.url,
            alt: photo === null || photo === void 0 ? void 0 : photo.description
        })
    });
};
/* harmony default export */ var AlbumContent_PhotoThumb = (PhotoThumb);

;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/HorizontalPhotoSlides.js

function HorizontalPhotoSlides_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    HorizontalPhotoSlides_templateObject = function() {
        return data;
    };
    return data;
}






const HorizontalPhotoSlides_StyledSwiper = (0,emotion_styled_browser_esm/* default */.Z)(swiper_react/* Swiper */.tq)(HorizontalPhotoSlides_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .swiper-wrapper {\n      margin-left: ".concat(theme.spacing(4), ";\n    }\n\n    .swiper-slide {\n      width: 58px;\n    }\n  ");
});
const HorizontalPhotoSlides = (param)=>{
    let { photos , photoUrlId , setPhotoUrlId  } = param;
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (!swiper) {
            return;
        }
        const index = photos === null || photos === void 0 ? void 0 : photos.findIndex((photo)=>photo.urlId === photoUrlId);
        if (index > -1 && (swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) !== index) {
            swiper.slideTo(index);
        }
    }, [
        photos,
        photoUrlId,
        swiper
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalPhotoSlides_StyledSwiper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        onAfterInit: (swiper)=>setSwiper(swiper),
        children: photos === null || photos === void 0 ? void 0 : photos.map((photo)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_PhotoThumb, {
                    photo: photo,
                    isSelected: photoUrlId === photo.urlId,
                    onClick: ()=>setPhotoUrlId(photo.urlId)
                })
            }, photo._id))
    });
};
HorizontalPhotoSlides.defaultProps = {
    photos: []
};
/* harmony default export */ var AlbumContent_HorizontalPhotoSlides = (HorizontalPhotoSlides);

// EXTERNAL MODULE: ./utils/api/general/genPathByNavData.js
var genPathByNavData = __webpack_require__(39086);
// EXTERNAL MODULE: ./store/cache/cacheSlice.js
var cacheSlice = __webpack_require__(24363);
;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/Controls.js








const Controls = (param)=>{
    let { album , closeModal  } = param;
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const onReserveClick = async ()=>{
        var _album_navData;
        dispatch((0,cacheSlice/* setNavigateInfo */.nb)({
            id: album._id,
            type: "Album"
        }));
        if (!!(album === null || album === void 0 ? void 0 : (_album_navData = album.navData) === null || _album_navData === void 0 ? void 0 : _album_navData.page)) {
            const { path , isExternalLink  } = await (0,genPathByNavData/* genPathByNavData */.E)(album.navData);
            if (path) {
                if (isExternalLink) {
                    window.open(path, "_blank");
                } else {
                    if (/^\/service\//.test(path)) {
                        var _album_vender;
                        dispatch((0,cacheSlice/* setPreselectVender */.bE)(((_album_vender = album.vender) === null || _album_vender === void 0 ? void 0 : _album_vender._id) || null));
                    }
                    if (closeModal) closeModal();
                    router.push(path);
                }
            }
        } else {
            if (closeModal) closeModal();
            router.push("/");
        }
    };
    const onConsultClick = ()=>{
        window.open("https://page.line.me/tyf8206o?openQrModal=true", "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        m: {
            xs: 5,
            lg: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 2,
            direction: "row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "consult",
                        className: "action",
                        variant: "outlined",
                        fullWidth: true,
                        onClick: onConsultClick,
                        children: "免費諮詢"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "book",
                        className: "action",
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        onClick: onReserveClick,
                        children: (album === null || album === void 0 ? void 0 : album.displayGotoReservation) || "前往預約"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AlbumContent_Controls = (Controls);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(17155);
// EXTERNAL MODULE: ./config/constants.js
var config_constants = __webpack_require__(73221);
// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(30905);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/Share.js


const ShareSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "share",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M11.293 1.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L13 4.414V15a1 1 0 11-2 0V4.414L8.707 6.707a1 1 0 01-1.414-1.414l4-4zM4 11a1 1 0 011 1v8a1 1 0 001 1h12a1 1 0 001-1v-8a1 1 0 112 0v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-8a1 1 0 011-1z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/SVGElements/Copy.js
var Copy = __webpack_require__(59811);
;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/ShareAlbum.js

function ShareAlbum_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ShareAlbum_templateObject = function() {
        return data;
    };
    return data;
}












const SquareIconButton = emotion_styled_browser_esm/* default.div */.Z.div(ShareAlbum_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    cursor: pointer;\n    padding: ".concat(theme.spacing(3), ";\n    background-color: white;\n    border-radius: 10px;\n    line-height: 1;\n  ");
});
const genLink = (route, photo)=>{
    const link = config_constants/* LS_APP_DOMAIN */._8 + route;
    return photo ? "".concat(link, "?photoId=").concat(photo) : link;
};
const ShareAlbum = (param)=>{
    let { album , photoUrlId  } = param;
    const router = (0,next_router.useRouter)();
    const [toast, setToast] = (0,react.useState)({
        open: false,
        message: ""
    });
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const onShareClick = async ()=>{
        var _router_asPath_split;
        const text = album.name;
        const url = genLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], photoUrlId);
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            (0,native_notifier/* shareUrlFromNative */.UP)(text, url);
        } else {
            const shareData = {
                title: "信義居家",
                text,
                url
            };
            try {
                await navigator.share(shareData);
                setToast({
                    open: true,
                    message: "分享成功"
                });
            } catch (err) {}
        }
    };
    const onCloneLinkClick = ()=>{
        var _router_asPath_split;
        const link = genLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], photoUrlId);
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            (0,native_notifier/* copyTextFromNative */.y6)(link);
            setToast({
                open: true,
                message: "複製完成"
            });
        } else {
            (0,helpers/* copyToClipboard */.vQ)(link);
            setToast({
                open: true,
                message: "複製完成"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 2.5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareIconButton, {
                    onClick: onShareClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSVG, {
                        textSecondary: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareIconButton, {
                    onClick: onCloneLinkClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* CopySVG */.s, {
                        textSecondary: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: toast.open,
                autoHideDuration: 6000,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                message: toast.message,
                onClose: ()=>setToast({
                        open: false,
                        message: ""
                    })
            })
        ]
    });
};
/* harmony default export */ var AlbumContent_ShareAlbum = (ShareAlbum);

// EXTERNAL MODULE: ./components/pages/Album/AlbumContent/MetaTags.js
var MetaTags = __webpack_require__(18680);
;// CONCATENATED MODULE: ./components/pages/Album/AlbumContent/index.js

function AlbumContent_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  ",
        "\n"
    ]);
    AlbumContent_templateObject = function() {
        return data;
    };
    return data;
}
function AlbumContent_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    AlbumContent_templateObject1 = function() {
        return data;
    };
    return data;
}
function AlbumContent_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AlbumContent_templateObject2 = function() {
        return data;
    };
    return data;
}
function AlbumContent_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AlbumContent_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 8px;\n  bottom: 10px;\n  z-index: 1;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
































const DynamicSearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9477), __webpack_require__.e(6541), __webpack_require__.e(8402), __webpack_require__.e(8277), __webpack_require__.e(1225)]).then(__webpack_require__.bind(__webpack_require__, 8277)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8277)
            ]
    }
});
const Background = emotion_styled_browser_esm/* default.div */.Z.div(AlbumContent_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      background-image: linear-gradient(90deg, ").concat(theme.palette.background.disabled, " 50%, white 50%);\n    }\n  ");
});
const Container = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* MaxWidthWrapper */.x)(AlbumContent_templateObject1());
const ContentContainer = emotion_styled_browser_esm/* default.div */.Z.div(AlbumContent_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    flex-grow: 1;\n    overflow: auto;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      overflow: hidden;\n      height: 100vh;\n    }\n  ");
});
const StyledGrid = (0,emotion_styled_browser_esm/* default */.Z)(Grid/* default */.ZP)(AlbumContent_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      height: 100%;\n    }\n  ");
});
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    display: flex;\n    flex-direction: column;\n    background-color: ".concat(theme.palette.background.disabled, ";\n    position: relative;\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      height: 100%;\n    }\n  ");
});
const AbsoluteButtonWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
const AbsolutePhotoCountWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
const AbsolutePhotoCount = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7(), (param)=>{
    let { theme  } = param;
    return "\n    display: inline-block;\n    color: white;\n    background-color: rgba(0, 0, 0, 0.7);\n    font-size: 10px;\n    border-radius: 24px;\n    padding: 2px 5px;\n  ";
});
const PhotoCount = (param)=>{
    let { photos , photoUrlId  } = param;
    if (!(photos === null || photos === void 0 ? void 0 : photos.length) || !photoUrlId) {
        return null;
    }
    const index = photos === null || photos === void 0 ? void 0 : photos.findIndex((photo)=>photo.urlId === photoUrlId);
    return index > -1 ? "".concat(index + 1, " / ").concat(photos === null || photos === void 0 ? void 0 : photos.length) : null;
};
const PhotoDescription = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* default */.Z)(_templateObject8(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      text-align: center;\n    }\n  ");
});
const LgHeight100Box = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject9(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      height: 100%;\n    }\n  ");
});
const FlexWrapper = (0,emotion_styled_browser_esm/* default */.Z)(LgHeight100Box)(_templateObject10(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      height: 100%;\n    }\n  ");
});
const InfoWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject11(), (param)=>{
    let { theme  } = param;
    return "\n    display: flex;\n    flex-direction: column-reverse;\n    padding: 0 ".concat(theme.spacing(4), ";\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      padding: 0 ").concat(theme.spacing(12), " 0 ").concat(theme.spacing(4), ";\n      flex-grow: 1;\n      overflow-y: auto;\n      flex-direction: column;\n    }\n  ");
});
const RoundedButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject12(), (param)=>{
    let { theme  } = param;
    return "\n    & {\n      padding-top: 8px;\n      padding-bottom: 8px;\n      border-radius: 20px;\n    }\n  ";
});
const genDescByTags = function() {
    let tagsGroupByCategory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _tagsGroupByCategory_filter_map, _tagsGroupByCategory_filter;
    return (_tagsGroupByCategory_filter_map = (_tagsGroupByCategory_filter = tagsGroupByCategory === null || tagsGroupByCategory === void 0 ? void 0 : tagsGroupByCategory.filter((data)=>(0,includes/* default */.Z)([
            "風格",
            "空間"
        ], data.category.name))) === null || _tagsGroupByCategory_filter === void 0 ? void 0 : _tagsGroupByCategory_filter.map((data)=>data.tags.map((tag)=>tag.name).join(" "))) === null || _tagsGroupByCategory_filter_map === void 0 ? void 0 : _tagsGroupByCategory_filter_map.join(" ");
};
const AlbumContent = (param)=>{
    let { onClose , closeModal , fallbackData , back  } = param;
    const router = (0,next_router.useRouter)();
    const albumUrlId = router.query.albumUrlId;
    const { data: album  } = useAlbum(albumUrlId, {
        fallbackData: (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.album) && [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.album
        ]
    });
    const { data: photos , isLoading: isPhotosLoading  } = usePhotos(album === null || album === void 0 ? void 0 : album._id, {
        limit: 999
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photos
    });
    const { data: tagCategories  } = (0,usePhotoClassifications/* usePhotoClassifications */.M)({}, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photoClassifications
    });
    const [photoUrlId, setPhotoUrlId] = (0,react.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photoUrlId) || null);
    (0,react.useEffect)(()=>{
        const photoNeedsUpdate = !photoUrlId || photoUrlId !== router.query.photoId;
        if (router.isReady && albumUrlId && !isPhotosLoading && photoNeedsUpdate) {
            var _photos_, _window_location_href_split;
            const targetPhotoUrlId = photoUrlId || (photos === null || photos === void 0 ? void 0 : (_photos_ = photos[0]) === null || _photos_ === void 0 ? void 0 : _photos_.urlId);
            const { albumUrlId: albumUrlId1 , ...rest } = router.query;
            const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
            const newQs = qs.split("&").filter((string)=>string && !/^(utm_|photoId=|PhotoId=)/.test(string)).concat([
                "photoId=".concat(targetPhotoUrlId)
            ]).join("&");
            window.history.replaceState(window.history.state, "", "?".concat(newQs));
            router.query.photoId = targetPhotoUrlId;
            setPhotoUrlId(targetPhotoUrlId);
        }
    }, [
        router.isReady,
        photos,
        isPhotosLoading,
        photoUrlId
    ]);
    const findPhoto = (items, urlId)=>{
        var _items_find;
        return items === null || items === void 0 ? void 0 : (_items_find = items.find) === null || _items_find === void 0 ? void 0 : _items_find.call(items, (item)=>item.urlId === urlId);
    };
    const [photo, setPhoto] = (0,react.useState)(findPhoto(photos, photoUrlId));
    (0,react.useEffect)(()=>{
        const newPhoto = findPhoto(photos, photoUrlId);
        if ((newPhoto === null || newPhoto === void 0 ? void 0 : newPhoto._id) !== (photo === null || photo === void 0 ? void 0 : photo._id)) {
            setPhoto(newPhoto);
        }
    }, [
        photos,
        photoUrlId
    ]);
    (0,react.useEffect)(()=>{
        if (photo) {
            setPhotoViewed(photo._id);
        }
    }, [
        photo
    ]);
    var _photo_publicViews;
    const photoViews = (_photo_publicViews = photo === null || photo === void 0 ? void 0 : photo.publicViews) !== null && _photo_publicViews !== void 0 ? _photo_publicViews : 0;
    const tagsGroupByCategory = (tagCategories || []).map((category)=>{
        var _photo_tags;
        return {
            category,
            tags: photo === null || photo === void 0 ? void 0 : (_photo_tags = photo.tags) === null || _photo_tags === void 0 ? void 0 : _photo_tags.filter((tag)=>tag.photoClassification === category._id)
        };
    }).filter((data)=>{
        var _data_tags;
        return data === null || data === void 0 ? void 0 : (_data_tags = data.tags) === null || _data_tags === void 0 ? void 0 : _data_tags.length;
    });
    const onCloseClick = (e)=>{
        if (onClose) {
            onClose(e);
        } else if (back) {
            router.back();
        } else {
            const path = router.query.rt ? decodeURIComponent(router.query.rt) : "/album";
            router.push(path);
        }
    };
    const [isDescriptionExpand, setIsDescriptionExpand] = (0,react.useState)(false);
    const webviewName = (0,es/* useSelector */.v9)(webviewSlice/* selectWebviewName */.TN);
    (0,react.useEffect)(()=>{
        if (webviewName === "lsApp") {
            try {
                (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(false);
                (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(true);
                (0,native_notifier/* enableNativeHeaderSearch */.PP)(false);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webviewName
    ]);
    const onTagClick = ()=>closeModal && closeModal();
    useGtmAlbumPageView(album, photos, photoUrlId);
    const isInModal = onClose || closeModal;
    const { searchPanelOpen , onSearchPanelClose  } = (0,hooks/* useSearchPanel */.J)(webviewName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isInModal && router.isReady && !!album && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                resolvedUrl: router.asPath,
                album: album,
                photos: photos,
                photoClassifications: tagCategories,
                photoUrlId: photoUrlId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    children: [
                        webviewName !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* HideInDesktopBox */.aI, {
                            display: "flex",
                            alignItems: "center",
                            my: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    flexGrow: 1,
                                    textAlign: "center",
                                    overflow: "hidden",
                                    pl: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                            children: album === null || album === void 0 ? void 0 : album.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: onCloseClick,
                                    size: "large",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* CloseSVG */.b, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                                container: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                                        item: true,
                                        xs: 12,
                                        lg: 8,
                                        xl: 9,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    height: "calc(100% - 68px)",
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_PhotoCarousel, {
                                                            photos: photos,
                                                            photoUrlId: photoUrlId,
                                                            frontCoverUrlId: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photoUrlId,
                                                            setPhotoUrlId: setPhotoUrlId
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AbsolutePhotoCountWrapper, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AbsolutePhotoCount, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoCount, {
                                                                        photos: photos,
                                                                        photoUrlId: photoUrlId
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoDescription, {
                                                        py: {
                                                            xs: 4,
                                                            lg: 6
                                                        },
                                                        color: "text.minus2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                                    fontWeight: "fontWeightBold",
                                                                    mr: 3,
                                                                    component: "span",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoCount, {
                                                                        photos: photos,
                                                                        photoUrlId: photoUrlId
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    component: "span",
                                                                    children: (photo === null || photo === void 0 ? void 0 : photo.description) || genDescByTags(tagsGroupByCategory)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AbsoluteButtonWrapper, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_ShareAlbum, {
                                                            album: album,
                                                            photoUrlId: photoUrlId
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                                        item: true,
                                        xs: 12,
                                        lg: 4,
                                        xl: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                                my: 4,
                                                minHeight: "58px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_HorizontalPhotoSlides, {
                                                    photos: photos,
                                                    photoUrlId: photoUrlId,
                                                    setPhotoUrlId: setPhotoUrlId
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                                                display: "flex",
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        px: 4,
                                                        pt: 4,
                                                        pm: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundedButton, {
                                                            variant: "contained",
                                                            size: "small",
                                                            onClick: onCloseClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* CloseSVG */.b, {
                                                                        white: true
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        ml: 1,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            children: "返回"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                                mt: 5,
                                                                mb: 4,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "h3",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        color: "text.minus2",
                                                                        children: album === null || album === void 0 ? void 0 : album.name
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                children: [
                                                                    (!!(album === null || album === void 0 ? void 0 : album.description) || !!(album === null || album === void 0 ? void 0 : album.vender)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Dashed */.B, {
                                                                            my: 4
                                                                        })
                                                                    }),
                                                                    !!(album === null || album === void 0 ? void 0 : album.vender) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        mb: 4,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderLink/* default */.Z, {
                                                                            vender: album === null || album === void 0 ? void 0 : album.vender
                                                                        })
                                                                    }),
                                                                    !!(album === null || album === void 0 ? void 0 : album.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                color: "textSecondary",
                                                                                children: isDescriptionExpand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: album.description
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                                                    $lines: 2,
                                                                                    children: album.description
                                                                                })
                                                                            }),
                                                                            !isDescriptionExpand && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                onClick: ()=>setIsDescriptionExpand(true),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                    color: "primary",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        mt: 1,
                                                                                        children: [
                                                                                            "展開",
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                                        pt: 6,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_Controls, {
                                                                            album: album,
                                                                            closeModal: closeModal
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Dashed */.B, {
                                                                        mt: {
                                                                            xs: 0,
                                                                            lg: 4
                                                                        },
                                                                        mb: 4
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        color: "textSecondary",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                            display: "flex",
                                                                            justifyContent: {
                                                                                xs: "none",
                                                                                lg: "space-between"
                                                                            },
                                                                            alignItems: "center",
                                                                            mb: 4,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                    fontWeight: "fontWeightBold",
                                                                                    mr: 6,
                                                                                    children: "圖片資訊"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* EyeSVG */.P, {
                                                                                            textSecondary: true
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                            ml: 2.5,
                                                                                            children: photoViews
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        color: "textSecondary",
                                                                        children: tagsGroupByCategory === null || tagsGroupByCategory === void 0 ? void 0 : tagsGroupByCategory.map((data)=>{
                                                                            var _data_tags;
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                                display: "flex",
                                                                                mb: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                            p: 3,
                                                                                            bgcolor: "background.gray",
                                                                                            fontWeight: "fontWeightBold",
                                                                                            whiteSpace: "nowrap",
                                                                                            children: data.category.name
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                        display: "flex",
                                                                                        flexWrap: "wrap",
                                                                                        pl: 2.5,
                                                                                        children: (_data_tags = data.tags) === null || _data_tags === void 0 ? void 0 : _data_tags.map((tag, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                                                children: [
                                                                                                    index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                                        py: 3,
                                                                                                        px: 2.5,
                                                                                                        children: "|"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                                        py: 3,
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                                                                            href: "/album?tag=".concat(tag.urlId),
                                                                                                            $textSecondary: true,
                                                                                                            onClick: onTagClick,
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                                                whiteSpace: "nowrap",
                                                                                                                children: tag.name
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }, tag._id))
                                                                                    })
                                                                                ]
                                                                            }, data.category._id);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                                component: "span",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Dashed */.B, {
                                                                            mt: 4
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            color: "textSecondary",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                fontWeight: "fontWeightBold",
                                                                                my: 6,
                                                                                children: "圖片系列照"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                            container: true,
                                                                            spacing: 2,
                                                                            children: photos === null || photos === void 0 ? void 0 : photos.map((photo)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                                    item: true,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_PhotoThumb, {
                                                                                        photo: photo,
                                                                                        isSelected: photoUrlId === photo.urlId,
                                                                                        onClick: ()=>setPhotoUrlId(photo.urlId)
                                                                                    })
                                                                                }, photo._id))
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                            mt: 12
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                            bgcolor: "white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumContent_Controls, {
                                album: album,
                                closeModal: closeModal
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchPanel, {
                open: !isInModal && webviewName === "lsApp" && searchPanelOpen,
                onClose: onSearchPanelClose
            })
        ]
    });
};
/* harmony default export */ var Album_AlbumContent = (AlbumContent);


/***/ })

}]);